import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
const resources = {
    en: {
        translation: {
            title: 'Compound Interest Calculator',
            whatAreYouSavingFor: 'Estimate your savings over time',
            savingsGoalDescription: 'Answer the questions below to estimate how your savings could grow based on your contributions and time frame.',
            initialContribution: 'How much can you contribute to start?',
            initialContributionSubtext: 'Tell us how much you\'d like to deposit to begin.',
            initialContributionTooltip: 'Choose anything between $0 - $100,000',
            contributionFrequency: 'How often will you contribute?',
            contributionFrequencySubtext: 'Choose how frequently you\'ll add to your savings.',
            contributionAmount: 'How much will you contribute each time?',
            contributionAmountSubtext: 'Enter the amount you plan to deposit regularly.',
            contributionAmountTooltip: 'Choose anything between $0 and $5,000',
            savingsPeriod: 'How long do you plan to save for?',
            savingsPeriodSubtext: 'Select the time frame that fits your savings goal.',
            interestRate: 'What is your expected savings interest rate?',
            interestRateSubtext: 'Enter your desired interest rate.',
            interestRateTooltip: 'To learn more visit: <a href="https://www.rbcroyalbank.com/rates/persacct.html" target="_blank">https://www.rbcroyalbank.com/rates/persacct.html</a>',
            learnMoreSavingsInterestRates: 'Learn more about savings interest rates',
            calculate: 'Calculate',
            startOver: 'Start Over',
            back: 'Back',
            resultHeading: 'You could save',
            youCouldSave: 'You could save',
            overTheNext: 'Over the next',
            totalDeposits: 'Total deposits',
            totalInterestEarned: 'Total interest earned',
            totalValue: 'Total value',
            readyToStartSaving: 'Ready to Start Saving?',
            readyToStartSavingText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            readyToStartSavingCta: 'View all Savings Accounts',
            learnMoreInterestRates: 'Learn more about interest rates',
            weekly: 'Weekly',
            biWeekly: 'Bi-weekly',
            monthly: 'Monthly',
            annually: 'Yearly',
            year: 'year',
            years: 'years',
            yearDropdown: 'year',
            yearsDropdown: 'years',
        },
    },
    fr: {
        translation: {
            title: "Calculateur d'intérêts composés",
            whatAreYouSavingFor: 'Estimez votre épargne au fil du temps',
            savingsGoalDescription: 'Répondez aux questions ci-dessous pour estimer l’évolution de votre épargne en fonction de vos cotisations et de votre horizon temporel.',
            initialContribution: 'Combien pouvez-vous verser pour commencer ?',
            initialContributionSubtext: 'Dites-nous quel montant vous souhaitez déposer pour commencer.',
            initialContributionTooltip: 'Choisissez un montant entre 0 $ et 10 000 $',
            contributionFrequency: 'Quelle sera la fréquence de cotisation ?',
            contributionFrequencySubtext: 'Choisissez la fréquence à laquelle vous ajouterez à votre épargne.',
            contributionAmount: 'Combien cotiserez-vous chaque fois ?',
            contributionAmountSubtext: 'Entrez le montant que vous prévoyez déposer régulièrement.',
            contributionAmountTooltip: 'Choisissez un montant entre 0 $ et 5 000 $',
            savingsPeriod: 'Pendant combien de temps prévoyez-vous épargner ?',
            savingsPeriodSubtext: 'Sélectionnez l’horizon de placement qui correspond à votre objectif d’épargne.',
            interestRate: "Quel est le taux d’intérêt de votre épargne prévu ?",
            interestRateSubtext: 'Entrez le taux d’intérêt souhaité',
            learnMoreSavingsInterestRates: 'En savoir plus sur les taux d’intérêt sur l’épargne',
            calculate: 'Calculer',
            startOver: 'Recommencer',
            back: 'Retour',
            resultHeading: 'Vous pourriez épargner',
            youCouldSave: 'Vous pourriez épargner',
            overTheNext: 'Au cours des prochaines',
            totalDeposits: 'Total des dépôts',
            totalInterestEarned: 'Total de l’intérêt acquis',
            totalValue: 'Valeur totale',
            readyToStartSaving: 'Prêt à commencer à épargner ?',
            readyToStartSavingText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            readyToStartSavingCta: 'Afficher tous les comptes d’épargne',
            learnMoreInterestRates: 'En savoir plus sur les taux d\'intérêt',
            weekly: 'Hebdomadaire',
            biWeekly: 'aux quinzaines',
            monthly: 'mensuelle',
            annually: 'annuelle',
            year: 'année',
            years: 'années',
            yearDropdown: 'an',
            yearsDropdown: 'ans',
        },
    },
};
i18n
    .use(initReactI18next)
    .init({
    resources,
    lng: 'en', // default language, will be overridden
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
});
export default i18n;
